import * as mutationTypes from 'store/mutationTypes'
import * as actions from './actions'

export default {
  state: {
    currentPlan: null,
    currentAffiliate: null,
  },
  actions,
  mutations: {
    [mutationTypes.SET_CURRENT_MEMBERSHIP_PLAN]: (state, plan) => {
      state.currentPlan = plan
    },
    [mutationTypes.SET_CURRENT_MEMBERSHIP_AFFILIATE]: (state, affiliate) => {
      state.currentAffiliate = affiliate
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/membership/index.js